export default __webpack_public_path__ + "static/media/arsiran.1e52c2d1.png";